/**
 * Cloud Binary LMS - WhatsApp Marketing Tracking & Attribution Utilities
 * Official Admissions Phone: +91 9100073006
 */

export const ADMISSIONS_PHONE = '919100073006';

export type MarketingSource = 'meta-ads' | 'google-ads' | 'youtube' | 'website' | 'referral' | 'direct';

export interface WhatsAppLinkOptions {
  source: MarketingSource;
  campaign?: string;
  course?: string;
  customMessage?: string;
}

/**
 * Generates a wa.me URL with standard tracking reference tags for Cloud Binary marketing channels
 */
export function getWhatsAppAdmissionsUrl(options: WhatsAppLinkOptions): string {
  const { source, campaign, course = 'Forward Deployed Engineer (FDE)', customMessage } = options;

  let refTag = '[REF:WEBSITE]';
  if (source === 'meta-ads') refTag = '[REF:META_ADS]';
  else if (source === 'google-ads') refTag = '[REF:GOOGLE_ADS]';
  else if (source === 'youtube') refTag = '[REF:YOUTUBE]';
  else if (source === 'referral') refTag = '[REF:ALUMNI]';

  const defaultText = customMessage || `Hi Cloud Binary Admissions Team, I am interested in the ${course} program and would like to speak with a mentor. ${refTag}${campaign ? ` [CAMP:${campaign}]` : ''}`;

  return `https://wa.me/${ADMISSIONS_PHONE}?text=${encodeURIComponent(defaultText)}`;
}

/**
 * Parses tracking references from inbound message text to identify marketing source
 */
export function detectSourceFromMessage(messageText: string): { source: MarketingSource; campaign?: string } {
  const text = messageText.toUpperCase();

  if (text.includes('[REF:META_ADS]') || text.includes('META') || text.includes('FACEBOOK') || text.includes('INSTAGRAM')) {
    return { source: 'meta-ads' };
  }
  if (text.includes('[REF:GOOGLE_ADS]') || text.includes('GOOGLE') || text.includes('GGL')) {
    return { source: 'google-ads' };
  }
  if (text.includes('[REF:YOUTUBE]') || text.includes('YOUTUBE') || text.includes('YT')) {
    return { source: 'youtube' };
  }
  if (text.includes('[REF:ALUMNI]') || text.includes('REFERRAL')) {
    return { source: 'referral' };
  }
  return { source: 'website' };
}
